/**
 * BB Short Videos Section JavaScript
 * Swiper initialization is now handled by BB-swiper-init.js via data attributes
 * This file handles iframe loading optimization and navigation visibility
 */

document.addEventListener('DOMContentLoaded', function () {
  // Initialize iframe loading optimization
  initializeIframeOptimization();

  // Listen for swiper:init events to set up navigation visibility
  document.addEventListener('swiper:init', function (e) {
    const swiper = e.detail.swiper;
    const swiperEl = e.detail.element;

    // Check if this is a bb-short-videos swiper
    if (!swiperEl.closest('.bb-short-videos')) return;

    // Handle navigation visibility
    function updateNavigationVisibility() {
      const navigation = swiperEl
        .closest('.bb-short-videos__carousel-wrapper')
        ?.querySelector('.bb-short-videos__navigation');

      if (navigation) {
        if (swiper.isBeginning && swiper.isEnd) {
          navigation.style.display = 'none';
        } else {
          navigation.style.display = 'flex';
        }
      }
    }

    // Update on swiper events
    updateNavigationVisibility();
    swiper.on('resize', updateNavigationVisibility);
    swiper.on('slidesLengthChange', updateNavigationVisibility);
    swiper.on('slideChange', updateNavigationVisibility);
  });

  function initializeIframeOptimization() {
    // Handle iframe loading optimization
    const iframes = document.querySelectorAll('.bb-short-videos__iframe');

    iframes.forEach((iframe) => {
      // Add loading="lazy" attribute for better performance
      if (!iframe.hasAttribute('loading')) {
        iframe.setAttribute('loading', 'lazy');
      }

      // Handle iframe load events
      iframe.addEventListener('load', function () {
        this.style.opacity = '1';
      });

      // Set initial opacity for smooth loading
      iframe.style.opacity = '0';
      iframe.style.transition = 'opacity 0.3s ease';
    });

    // Intersection Observer for lazy loading optimization
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const iframe = entry.target.querySelector('.bb-short-videos__iframe');
              if (iframe && !iframe.src.includes('autoplay=1')) {
                // Optional: Enable autoplay when video comes into view
                // iframe.src = iframe.src.replace('autoplay=0', 'autoplay=1');
              }
            }
          });
        },
        {
          rootMargin: '50px',
          threshold: 0.3,
        }
      );

      // Observe all video items
      const videoItems = document.querySelectorAll('.bb-short-videos__item');
      videoItems.forEach((item) => {
        videoObserver.observe(item);
      });
    }
  }
});
